import { createSlice } from "@reduxjs/toolkit";

const activeLinkSlice = createSlice({
  name: "activeLink",
  initialState: {
    currentLink: "",
  },
  reducers: {
    setActiveLink: (state, action) => {
      state.currentLink = action.payload;
    },
  },
});

export const {  } = activeLinkSlice.actions;
export default activeLinkSlice.reducer;
